export const LOCALE_TITLES: any = {
    fr: "Langues Vivantes: Bienvenue à Bruges !",
    en: "Easy Languages: Welcome to Bruges!",
    nl: "Easy Languages: Welkom in Brugge!",
    es: "Easy Languages: Bienvenido a Brujas!"
}